define(function(require, exports, module) {
    'use strict';

    var base = require('base');

    module.name = 'ui.input-overflow';

    module.exports = base.createModule(module.name, [])
        .directive(require('./directives'));
});



//////////////////
// WEBPACK FOOTER
// ./scripts/components/input-overflow/scripts/main.js
// module id = 23
// module chunks = 0